import Component from '../colorz/Component';
import Splide from '@splidejs/splide';
import {sliderOptions} from '../colorz/configClrzApp';
import CardProduct from './CardProduct';

export default class HistoricalsProduct extends Component {
	onInit(el) {
		this.el = el;
		this.storageContent = [];
		this.type = this.el.dataset.typePage;
		// si la strate historique existe
		this.strate = this.el.querySelector('.js-historical-strate');
		// set slider
		this.slider = this.el.querySelector('.js-historical-slider');
		this.defaultOptions = sliderOptions.default;
		if (this.slider) {
			this.options = !!this.slider.dataset.options
				? sliderOptions[this.slider.dataset.options]
				: {};
			this.options = {...this.defaultOptions, ...this.options};
			this.splide = null;
			this.initSlider = this.initSlider.bind(this);
			this.initCard = this.initCard.bind(this);
		}
		this.productsToShow = Number(this.el?.dataset?.productsToShow) || 10;
	}

	onReady() {
		// On récupère le contenu du storage
		this.getLocalStorage();
		// si on est sur une page produit on récupère le produit et on l'ajoute
		if (this.type == 'product') {
			this.product = JSON.parse(
				this.el.querySelector('[data-product-json]').innerHTML,
			);
			// On ajoute le produit que s'il n'est pas déjà dans le storage
			if (
				this.storageContent.find((el) => el.id == this.product.id) == undefined
			) {
				this.addToStorage();
			}
		}
		if (this.storageContent.length > 2 && this.strate) {
			this.fetchProduct();
		}
	}
	getLocalStorage() {
		const storage = window.localStorage.getItem('historicalProducts');
		this.storageContent = [...new Set(JSON.parse(storage))];
	}
	addToStorage() {
		// Si plus de x elements, enlever le 1er (le plus vieux) et ajouter le nouveau
		while (this.storageContent.length > this.productsToShow - 1) {
			this.storageContent.shift();
		}
		this.storageContent.push(this.product);
		window.localStorage.setItem(
			'historicalProducts',
			JSON.stringify(this.storageContent),
		);
	}
	removeFromStorage(id) {
		const filteredStorage = this.storageContent.filter((item) => item.id != id);
		window.localStorage.setItem(
			'historicalProducts',
			JSON.stringify(filteredStorage),
		);
	}

	async fetchProduct() {
		const promises = [];

		this.storageContent.toReversed().forEach((el, index) => {
			const fetchUrl = new URL(window.location);
			fetchUrl.pathname = `/products/${el.handle}`;
			fetchUrl.searchParams.append('view', 'card-product');

			if (index >= this.productsToShow) return; // loop until productsToShow

			promises.push(
				new Promise((resolve) =>
					fetch(fetchUrl)
						.then((response) => {
							if (response.ok) {
								return response.text();
							} else {
								this.removeFromStorage(el.id); // si 404 on suppr le produit du storage
							}
						})
						.then((response) => {
							const html = response;
							this.renderProduct(html);
							resolve();
						}),
				),
			);
		});

		await Promise.all(promises).then(() => {
			this.initSlider();

			if (this.storageContent.length < 3) {
				this.strate.querySelector('.splide__arrows').classList.add('u-hidden');
			}

			this.displayStrate();
		});
	}
	renderProduct(html) {
		this.strateContent = this.strate.querySelector(
			'.js-historical-strate-content',
		);
		const innerHTML = new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector('[data-id=card-product]');

		if (innerHTML) {
			innerHTML.classList.add('splide__slide');
			this.strateContent.appendChild(innerHTML);
		}
	}
	displayStrate() {
		this.strate.classList.remove('u-hidden');
	}
	initSlider() {
		this.splide = new Splide(this.slider, this.options);

		setTimeout(() => {
			this.splide.mount();

			if (this.slider.dataset.positionArrows == 'true') {
				const topArrow =
					this.slider.querySelector('.splide__slide img')?.offsetHeight / 2;
				this.slider
					.querySelectorAll('.splide__arrow-wrapper')
					.forEach((arrow) => {
						arrow.style.top = topArrow + 'px';
					});
			}
		}, 10);
	}
	initCard() {
		this.strate.querySelectorAll('.js-card-product').forEach((item) => {
			new CardProduct(item);
		});
	}
}
